import React, { useContext, useEffect } from "react";
import SecondaryButton from "../generated/SecondaryButton";
import { Link } from "@mui/material";
import { NavigationContext } from "../../context/NavigationContext";
import { withRouterUtilities } from "../../util/withRouterUtilities";
import AppRoutes from "../../config/AppRoutes";

const NextButton = (props) => {
  const context = useContext(NavigationContext);
  const disabled = context.nextButtonDisabled;
  const onClick = context.onSubmit;
  const nextButtonVisible = context.nextButtonVisible;
  useEffect(() => {
    // Certain pages determine disable state on mount, and should be excluded
    if (
      ![
        AppRoutes.PURCHASE_IRQ_WAIVE_ESCROW_PAGE,
        AppRoutes.BUILD_IRQ_WAIVE_ESCROW_PAGE,
        AppRoutes.REFINANCE_IRQ_WAIVE_ESCROW_PAGE,
      ].includes(props.location.pathname)
    ) {
      context.setNextButtonDisabled(false);
    }
  }, [props.location.pathname]);

  if (!nextButtonVisible) {
    return null;
  }

  return (
    <div className="next-button-wrapper">
      <Link
        className="navigation-link"
        onClick={() => (!disabled ? onClick() : null)}
      >
        <SecondaryButton disabled={disabled} {...props}>
          <img className="next-button-circle" src="/img/down_arrow.svg" />
        </SecondaryButton>
        <label className="navigation-label">Next</label>
      </Link>
    </div>
  );
};

export default withRouterUtilities(NextButton);
